import { useSearchParams } from 'react-router'

import { REVIEW_PARAM } from '~/notes/constants'

export const useIsReview = () => {
  const [searchParams] = useSearchParams()
  return searchParams.get(REVIEW_PARAM) !== null
}
